import { Table, TableTfootProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type RegistryTableTfootProps = TableTfootProps;

export const createRegistryTableTfoot = () => {
	const RegistryTableTfoot = forwardRef<HTMLTableSectionElement, RegistryTableTfootProps>(
		({ className, ...props }, ref) => (
			<Table.Tfoot
				ref={ref}
				className={clsx('registry-table-tfoot', className)}
				{...props}
			/>
		),
	);

	return RegistryTableTfoot;
};
